/**
 * Comparação de versão usada pelas travas de atualização do app.
 *
 * As três travas (index.html, App.js e ConsultaChat.jsx) comparavam por
 * desigualdade, então uma página de versão ANTERIOR à conhecida — a cópia de
 * emergência que o service worker serve quando a navegação estoura o tempo —
 * era lida como "versão nova", disparando limpeza de armazenamento e reload
 * com a versão velha na URL. Em rede lenta isso vira ciclo: 12 reinícios em
 * 20 minutos no caso de 29/09/2026, cada um matando a galeria aberta e
 * perdendo a foto que o paciente ia anexar.
 */

/** -1 se a < b, 0 se iguais, 1 se a > b. Versão ausente ou placeholder → 0. */
export function compareAppVersions(a, b) {
  if (!a || !b) return 0;
  if (String(a).indexOf('{{') === 0 || String(b).indexOf('{{') === 0) return 0;
  const pa = String(a).split('.');
  const pb = String(b).split('.');
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i += 1) {
    const na = parseInt(pa[i], 10) || 0;
    const nb = parseInt(pb[i], 10) || 0;
    if (na > nb) return 1;
    if (na < nb) return -1;
  }
  return 0;
}

/**
 * A página atual é anterior à versão que o aparelho já conhece (ou é a cópia
 * de emergência do service worker)? Nesse caso nada de limpar armazenamento
 * nem recarregar: quem está desatualizado é o HTML servido, não os dados.
 */
export function isStalePageVersion(storedVersion, currentVersion) {
  if (typeof window !== 'undefined' && window.__CM_SHELL_FALLBACK__) return true;
  return compareAppVersions(storedVersion, currentVersion) > 0;
}

/** Só atualiza para frente: versão guardada menor que a do bundle carregado. */
export function shouldRefreshForNewVersion(storedVersion, currentVersion) {
  if (!storedVersion || !currentVersion) return false;
  if (isStalePageVersion(storedVersion, currentVersion)) return false;
  return compareAppVersions(storedVersion, currentVersion) < 0;
}
